import React, { Component } from "react";
import "./ExitModal.css";
import InfoIcon from './InfoIcon'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

export default class ExitModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: this.props.activeItem,
      clicked_id:null,
      clicked_eid: null,
      dropdown: false,
      isValid: true,
      validationErrors: [],
      loading: false,
    };
  }

  validateInput = () => {
    let errors = [];
    if (this.state.clicked_id === null) {
      errors.push(<li key={"eid"}>Select a gateway node</li>);
    }
    if (errors.length > 0) {
      this.setState({ isValid: false, validationErrors: errors });
      return false;
    }
    this.setState({ isValid: true, validationErrors: [] });
    return true;
  };

  handleChange = (e) => {
    let { name, value } = e.target;
    const activeItem = { ...this.state.activeItem, [name]: value };
    this.setState({ activeItem });
  };

  setLastClicked = (item) => {
    this.setState({ clicked_id: item.uuid });
    this.setState({ clicked_eid: item.eid });
  };

  renderHosts = () => {
    const hosts = this.props.nodeList;
    const user = this.props.user;
    const selectedNode = this.props.activeItem.eid;
    return hosts.map((item) =>
      item.owner === user && item.eid !== selectedNode ? (
        <DropdownItem
          key={item.eid}
          onClick={() => this.setLastClicked(item)}
        >
          Node {item.eid}
        </DropdownItem>
      ) : null
    );
  };

  dropdownToggle = () => {
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const { exitToggle, getErrors, onSave } = this.props;

    return (
      <Modal modalClassName="ExitModal" isOpen={true} toggle={exitToggle}>
        <ModalHeader>
          {" "}
          Assign Gateway{" "}
          <button className="exit_close_button" onClick={exitToggle}>
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          Assign gateway for node {this.props.activeItem.eid}
          <InfoIcon infoText={"Other nodes will communicate with node " + this.props.activeItem.eid + " via the selected gateway."} position={"right"}/>
          <div className="error_area">
            <ul style={{ color: "red" }}>
              {this.state.isValid ? getErrors() : this.state.validationErrors}
            </ul>
          </div>
          <div className="button_area">
            <div className="exit_dropdown_area">
              <ButtonDropdown
                isOpen={this.state.dropdown}
                toggle={this.dropdownToggle}
              >
                <DropdownToggle caret>
                  {this.state.clicked_id
                    ? `Node ${this.state.clicked_eid}`
                    : " Gateway Node"}
                </DropdownToggle>
                <DropdownMenu>{this.renderHosts()}</DropdownMenu>
              </ButtonDropdown>
            </div>
            <button
              className="exit_button"
              disabled={this.state.loading}
              onClick={() => {
                if (this.validateInput()) {
                  const activeItem = this.state.activeItem;
                  activeItem["parent_node"]=this.state.clicked_id.toString();
                  this.setState({activeItem: activeItem, loading: true});
                  onSave(this.state.activeItem);
                }
              }}
            >
              {this.state.loading ? "Loading..." : "Assign Gateway"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
